import React from "react";

function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 2 1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8z" />
      <path d="m18.5 14 1 2.8 2.8 1-2.8 1-1 2.8-1-2.8-2.8-1 2.8-1z" />
    </svg>
  );
}

export default function AiFieldActions({
  onGenerate,
  onRewrite,
  disabled = false,
  loadingMode = "",
  helper = "AI assist"
}) {
  return (
    <div className="ai-field-actions">
      <span className="muted ai-field-helper">
        <SparkIcon />
        {helper}
      </span>
      <div className="ai-field-buttons">
        <button type="button" className="button-link ghost ai-mini-btn ai-spark-btn" onClick={onGenerate} disabled={disabled || loadingMode !== ""} title="Generate a draft using current context">
          <SparkIcon />
          {loadingMode === "generate" ? "AI Generating..." : "AI Generate"}
        </button>
        <button type="button" className="button-link ghost ai-mini-btn ai-spark-btn" onClick={onRewrite} disabled={disabled || loadingMode !== ""} title="Rewrite the current text professionally">
          <SparkIcon />
          {loadingMode === "rewrite" ? "AI Rewriting..." : "AI Rewrite"}
        </button>
      </div>
    </div>
  );
}
